<template>
  <div v-show="show" :style="`z-index:${highestZIndex + 108};line-height: 18px !important;`">
    <div
      class="scToolTip"
      :class="[alignClass,tipClass,sizeClass]"
      :style="`z-index:${highestZIndex + 5}`"
    >
      <div v-if="text" class="sc-tooltip-inner" v-html="text"></div>
      <div v-else class="sc-tooltip-inner">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "top",
    },
    tip: {
      type: String,
      default: "bottom-left",
    },
    show: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
  },
  computed: {
    alignClass() {
      return `tooltip-placement-${this.align}`;
    },
    tipClass() {
      return `tooltip-tip-${this.tip}`;
    },
    sizeClass() {
      if (this.size == "lg") {
        return `tooltip-lg`;
      }
      return ``;
    },
  },
};
</script>



// WEBPACK FOOTER //
// BaseToolTip.vue?0fe9af06